import Vue from 'vue';
import { Component, Emit, Prop } from 'vue-property-decorator';
import { DateTimeHelper } from '../../../../utils/DateTimeHelper.util';

@Component
class TicketChatMessageTimeNotifStatus extends Vue {
  @Prop({ required: true, type: [Object] })
  source: any;

  constructor() {
    super();
  }

  get displayStatus(): boolean {
    if (!this.source.notifications) return false
    return this.source.notifications.length > 0
  }

  get displayAllDone(): boolean {
    return this.source.notifications.filter(x => !x.is_watched).length === 0
  }

  get coTime(): string {
    return DateTimeHelper.parseTimeWithoutUtc(this.source.createdAt);
  }
}

export default TicketChatMessageTimeNotifStatus;


// WEBPACK FOOTER //
// ./src/containers/ticket/components/ticket-chat-message-time-notif-status/index.ts